var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBattery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002455;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24.448,
    height: 12.199,
    transform: "translate(5.275 13.383)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0-.75H24.448A.75.75,0,0,1,25.2,0V12.2a.75.75,0,0,1-.75.75H0a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75ZM23.7.75H.75v10.7H23.7Z",
    transform: "translate(5.275 13.383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.348,13.383h-1.5V10.168H9.3v3.216H7.8V9.418a.75.75,0,0,1,.75-.75H14.6a.75.75,0,0,1,.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M27.2,13.383H25.7V10.168H21.152v3.216h-1.5V9.418a.75.75,0,0,1,.75-.75h6.051a.75.75,0,0,1,.75.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.838.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H4.838a.75.75,0,0,1,.75.75A.75.75,0,0,1,4.838.75Z",
    transform: "translate(9.154 19.482)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.838.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H4.838a.75.75,0,0,1,.75.75A.75.75,0,0,1,4.838.75Z",
    transform: "translate(21.008 19.482)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,5.588a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V4.838A.75.75,0,0,1,0,5.588Z",
    transform: "translate(23.428 17.064)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon_battery.485e47dfae1118da1200b729509770e6.svg";
export { ForwardRef as ReactComponent };